import axios from "@/lib/axios";
import { DimensionId } from "@/types/questionnaries";

export type QuestionsByDimensionRequestParams = {
  companyId: string;
  applicationQuizId: string;
  dimensionId: DimensionId;
};

export type QuestionsByDimensionResponse = Array<{
  topic: string;
  topicName: string;
  questions: Array<{
    id: string;
    title: string;
    statement: string;
    order: number;
  }>;
}>;

export const questionsByDimension = (
  params: QuestionsByDimensionRequestParams,
) =>
  axios
    .get<QuestionsByDimensionResponse>(
      `/v1/companies/${params.companyId}/application-quizzes/${params.applicationQuizId}/questions/${params.dimensionId}`,
    )
    .then((res) => res.data);
